import {Typography, useTheme, css} from '@mui/material';
import {DlMuiDeleteButton, GetStylesFunction} from '@wallaby-ui/core';
import {ICellRendererParams} from 'ag-grid-community';
import * as React from 'react';
import {FC} from 'react';

import {getHaiTypeColor} from './HaidiHaiTypeFormatter';
import {useFormatters} from '../light';
import {TooltipWrapper} from '../TooltipWrapper';

type OwnProps = ICellRendererParams;

type Props = OwnProps;

export const HaidiHaiTypeIconFormattedChip: FC<{
  value: any;
  state: any;
  showAsText?: boolean;
  showTooltip?: boolean;
  valueTranslated?: string;
  useEllipsis?: boolean;
  onDelete?: () => void;
  textColor?: string;
}> = (props) => {
  const {value, state, textColor, showAsText = false, showTooltip = true, valueTranslated, useEllipsis = false} = props;
  const theme = useTheme();
  const styles = getStyles({theme, params: {showAsText, textColor}});
  const linkWrapperStyles = useEllipsis ? styles.ellipsisLinkWrapper : styles.linkWrapper;
  const {tEnum, t} = useFormatters();
  let valueLabel = valueTranslated || tEnum('HaiTypeEnum', value);
  if (value === 'BSI') {
    valueLabel = valueLabel.replace(/\s*\([^)]*\)/g, '').trim();
  }
  const colors = getHaiTypeColor({type: value, state});
  const formattedElement = (
    <span css={styles.chip} data-name='hai-type-formatter'>
      <span css={styles.icon} style={{background: colors.background ?? 'lightgray'}} />
      <Typography css={linkWrapperStyles} variant={'value'}>
        {valueLabel}
      </Typography>
      {props.onDelete && (
        <DlMuiDeleteButton
          iconTitle={t('autoLayout.button.remove')}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            props.onDelete?.();
          }}
          inputCss={styles.deleteBtn}
          iconBackgroundCss={styles.deleteBtnBg}
          svgIconInputCss={styles.deleteBtnIcon}
        />
      )}
    </span>
  );
  return showTooltip ? <TooltipWrapper tooltip={valueLabel}>{formattedElement}</TooltipWrapper> : formattedElement;
};
HaidiHaiTypeIconFormattedChip.displayName = 'HaidiHaiTypeIconFormattedChip';

export const HaidiHaiTypeIconFormatter: React.FC<Props> = (props) => {
  const {value, data} = props;

  return <HaidiHaiTypeIconFormattedChip value={value} state={data.state} />;
};
HaidiHaiTypeIconFormatter.displayName = 'HaidiHaiTypeIconFormatter';

const getStyles: GetStylesFunction = (options) => ({
  chip: css`
    border-radius: 12px;
    padding: 3px 8px;
    padding-right: ${options?.params?.showAsText ? '2px' : '8px'};
    padding-top: ${options?.params?.showAsText ? '0px' : '3px'};
    padding-bottom: ${options?.params?.showAsText ? '0px' : '3px'};
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border: ${options?.params?.showAsText ? undefined : '1px solid #e2e8f2'};
    background: ${options?.params?.showAsText ? 'unset' : '#ffffff'};
    color: ${options?.params?.textColor || '#5d6f88'};
    max-width: 100%;
    min-width: 0;
  `,
  icon: css`
    display: inline-flex;
    border-radius: 50%;
    width: 13px;
    height: 13px;
    flex-shrink: 0;
  `,
  ellipsisLinkWrapper: css`
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
    max-width: 100%;
  `,
  deleteBtn: css`
    padding: 0;
    margin-left: 2px;
    flex: 0 0 auto;
  `,
  deleteBtnBg: css`
    width: 14px;
    height: 14px;
    border-radius: 7px;
  `,
  deleteBtnIcon: css`
    font-size: 0.9em;
  `,
});
